import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Authenticated property routes, mounted under the AppLayout shell.
// - PROPERTIES       : the seller's promoted properties + portfolio status
// - PROPERTY_DETAIL  : one property's status, facts and documents
//
// There is no create route: a seller cannot create a property. Properties exist
// only because an admin promoted an approved, signed sell request.
export const propertyRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROPERTIES,
    name: 'PROPERTIES',
    component: () => import('./PropertiesListPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Live Listing Portfolio',
      subtitle: 'Real-time status updates, active yields, and regulatory transaction audits.',
    },
  },
  {
    path: routes.PROPERTY_DETAIL,
    name: 'PROPERTY_DETAIL',
    component: () => import('./PropertyDetailPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Property Details',
      subtitle: 'Status, registry details, and documents for this property.',
    },
  },
]
